import ReactDOM from 'react-dom';
import h from 'react-hyperscript';
import { ApolloProvider } from 'react-apollo';
import { ConnectedRouter } from 'react-router-redux';

import configureStore from './store/configureStore';
import createRoutes from './routes';
import history from './history';
import createClient from './lib/apolloClient';

import './assets'; // Import common static assets

const client = createClient();
const store = configureStore(client);
const routes = createRoutes();

const renderProvider = h(ApolloProvider, { store, client }, [
  h(ConnectedRouter, { onUpdate: () => window.scrollTo(0, 0), history }, [routes]),
]);

ReactDOM.render(renderProvider, document.getElementById('root'));

if (module.hot) {
  module.hot.accept();
}



// WEBPACK FOOTER //
// ./src/index.js